import { useConfiguration } from '~/context/common/StaticContext';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';

export default function useShowVaultWhyBuyContent(): boolean {
  const { useVaultWhyBuy = false } = useConfiguration();
  const { narrativeContent } = useGetVaultWhyBuyNarrative();

  return (
    useVaultWhyBuy &&
    Boolean(narrativeContent?.summary) &&
    Array.isArray(narrativeContent?.bulletPoints) &&
    (narrativeContent?.bulletPoints?.length ?? 0) > 0
  );
}
